// useLocalStorage.js
import { useEffect, useState } from "react";

export function useLocalStorage(key) {
  const [value, setValue] = useState(localStorage.getItem(key));

  const setLocalStorageValue = (newValue) => {
    localStorage.setItem(key, newValue);
    setValue(newValue);

    // Dispatch a custom event to notify other components in the same tab
    window.dispatchEvent(new Event("localStorageChange"));
  };

  useEffect(() => {
    const handleStorageChange = () => {
      setValue(localStorage.getItem(key));
    };

    window.addEventListener("localStorageChange", handleStorageChange);

    return () => {
      window.removeEventListener("localStorageChange", handleStorageChange);
    };
  }, [key]);

  return [value, setLocalStorageValue];
}
